// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-time-picker-clock {
  background: rgb(var(--v-theme-background));
  color: rgb(var(--v-theme-on-background));
}
:where(.vuetify-styles) .v-time-picker-clock:after {
  color: rgb(var(--v-theme-primary));
}
:where(.vuetify-styles) .v-time-picker-clock .v-time-picker-clock__item--active {
  background-color: rgb(var(--v-theme-surface-variant));
  color: rgb(var(--v-theme-on-surface-variant));
}

:where(.vuetify-styles) .v-time-picker-clock {
  margin: 24px;
  background: rgb(var(--v-theme-surface-light));
  border-radius: 50%;
  position: relative;
  transition: none;
  -webkit-user-select: none;
          user-select: none;
  max-width: 256px;
  aspect-ratio: 1;
  flex: 100%;
}
:where(.vuetify-styles) .v-time-picker-clock__container {
  display: flex;
  flex-direction: column;
  flex-basis: 290px;
  justify-content: center;
  padding: 10px;
}
:where(.vuetify-styles) .v-time-picker-clock__hand {
  background-color: currentColor;
  height: calc(50% - 4px);
  width: 2px;
  bottom: 50%;
  left: calc(50% - 1px);
  transform-origin: center bottom;
  position: absolute;
  will-change: transform;
  z-index: 1;
}
:where(.vuetify-styles) .v-time-picker-clock__hand:before {
  background: transparent;
  border-width: 2px;
  border-style: solid;
  border-color: currentColor;
  border-radius: 100%;
  width: 10px;
  height: 10px;
  content: "";
  position: absolute;
  top: -4px;
  left: 50%;
  transform: translate(-50%, -50%);
}
:where(.vuetify-styles) .v-time-picker-clock__hand:after {
  content: "";
  position: absolute;
  height: 8px;
  width: 8px;
  top: 100%;
  left: 50%;
  border-radius: 100%;
  background-color: currentColor;
  transform: translate(-50%, -50%);
}
:where(.vuetify-styles) .v-time-picker-clock__hand--inner:after {
  height: 14px;
}
:where(.vuetify-styles) .v-time-picker-clock--readonly {
  pointer-events: none;
}
:where(.vuetify-styles) .v-time-picker-clock .v-time-picker-clock__item--disabled {
  opacity: var(--v-disabled-opacity);
}

:where(.vuetify-styles) .v-picker--full-width .v-time-picker-clock__container {
  max-width: 290px;
}

:where(.vuetify-styles) .v-time-picker-clock__inner {
  position: absolute;
  bottom: 27px;
  left: 27px;
  right: 27px;
  top: 27px;
}

:where(.vuetify-styles) .v-time-picker-clock__item {
  align-items: center;
  border-radius: 100%;
  cursor: default;
  display: flex;
  font-size: 16px;
  justify-content: center;
  height: 40px;
  position: absolute;
  text-align: center;
  width: 40px;
  -webkit-user-select: none;
          user-select: none;
  transform: translate(-50%, -50%);
}
:where(.vuetify-styles) .v-time-picker-clock__item > span {
  z-index: 1;
}
:where(.vuetify-styles) .v-time-picker-clock__item:before, :where(.vuetify-styles) .v-time-picker-clock__item:after {
  content: "";
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  height: 14px;
  width: 14px;
  transform: translate(-50%, -50%);
}
:where(.vuetify-styles) .v-time-picker-clock__item:after, :where(.vuetify-styles) .v-time-picker-clock__item:before {
  height: 40px;
  width: 40px;
}
:where(.vuetify-styles) .v-time-picker-clock__item--active {
  cursor: default;
  z-index: 2;
}
:where(.vuetify-styles) .v-time-picker-clock__item--disabled {
  pointer-events: none;
}

:where(.vuetify-styles) .v-picker--landscape .v-time-picker-clock__container {
  flex-direction: row;
}

@media (forced-colors: active) {
  :where(.vuetify-styles) .v-time-picker-clock__hand {
    background-color: highlight;
  }
  :where(.vuetify-styles) .v-time-picker-clock__hand:before {
    border-color: highlight;
  }
  :where(.vuetify-styles) .v-time-picker-clock__hand:after {
    background-color: highlight;
  }
  :where(.vuetify-styles) .v-time-picker-clock__item--active {
    outline: 2px solid highlight !important;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VTimePicker/VTimePickerClock.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,SAAS;EACT,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uCAAuC;EACzC;AACF","sourcesContent":[".v-time-picker-clock {\n  background: rgb(var(--v-theme-background));\n  color: rgb(var(--v-theme-on-background));\n}\n.v-time-picker-clock:after {\n  color: rgb(var(--v-theme-primary));\n}\n.v-time-picker-clock .v-time-picker-clock__item--active {\n  background-color: rgb(var(--v-theme-surface-variant));\n  color: rgb(var(--v-theme-on-surface-variant));\n}\n\n.v-time-picker-clock {\n  margin: 24px;\n  background: rgb(var(--v-theme-surface-light));\n  border-radius: 50%;\n  position: relative;\n  transition: none;\n  user-select: none;\n  max-width: 256px;\n  aspect-ratio: 1;\n  flex: 100%;\n}\n.v-time-picker-clock__container {\n  display: flex;\n  flex-direction: column;\n  flex-basis: 290px;\n  justify-content: center;\n  padding: 10px;\n}\n.v-time-picker-clock__hand {\n  background-color: currentColor;\n  height: calc(50% - 4px);\n  width: 2px;\n  bottom: 50%;\n  left: calc(50% - 1px);\n  transform-origin: center bottom;\n  position: absolute;\n  will-change: transform;\n  z-index: 1;\n}\n.v-time-picker-clock__hand:before {\n  background: transparent;\n  border-width: 2px;\n  border-style: solid;\n  border-color: currentColor;\n  border-radius: 100%;\n  width: 10px;\n  height: 10px;\n  content: \"\";\n  position: absolute;\n  top: -4px;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.v-time-picker-clock__hand:after {\n  content: \"\";\n  position: absolute;\n  height: 8px;\n  width: 8px;\n  top: 100%;\n  left: 50%;\n  border-radius: 100%;\n  background-color: currentColor;\n  transform: translate(-50%, -50%);\n}\n.v-time-picker-clock__hand--inner:after {\n  height: 14px;\n}\n.v-time-picker-clock--readonly {\n  pointer-events: none;\n}\n.v-time-picker-clock .v-time-picker-clock__item--disabled {\n  opacity: var(--v-disabled-opacity);\n}\n\n.v-picker--full-width .v-time-picker-clock__container {\n  max-width: 290px;\n}\n\n.v-time-picker-clock__inner {\n  position: absolute;\n  bottom: 27px;\n  left: 27px;\n  right: 27px;\n  top: 27px;\n}\n\n.v-time-picker-clock__item {\n  align-items: center;\n  border-radius: 100%;\n  cursor: default;\n  display: flex;\n  font-size: 16px;\n  justify-content: center;\n  height: 40px;\n  position: absolute;\n  text-align: center;\n  width: 40px;\n  user-select: none;\n  transform: translate(-50%, -50%);\n}\n.v-time-picker-clock__item > span {\n  z-index: 1;\n}\n.v-time-picker-clock__item:before, .v-time-picker-clock__item:after {\n  content: \"\";\n  border-radius: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  height: 14px;\n  width: 14px;\n  transform: translate(-50%, -50%);\n}\n.v-time-picker-clock__item:after, .v-time-picker-clock__item:before {\n  height: 40px;\n  width: 40px;\n}\n.v-time-picker-clock__item--active {\n  cursor: default;\n  z-index: 2;\n}\n.v-time-picker-clock__item--disabled {\n  pointer-events: none;\n}\n\n.v-picker--landscape .v-time-picker-clock__container {\n  flex-direction: row;\n}\n\n@media (forced-colors: active) {\n  .v-time-picker-clock__hand {\n    background-color: highlight;\n  }\n  .v-time-picker-clock__hand:before {\n    border-color: highlight;\n  }\n  .v-time-picker-clock__hand:after {\n    background-color: highlight;\n  }\n  .v-time-picker-clock__item--active {\n    outline: 2px solid highlight !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
